import * as React from 'react';

function SvgMute(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.985 10.736l5.507-4.121a.7.7 0 011.12.56v16.154a.7.7 0 01-1.12.56l-5.507-4.12h-2.87a.7.7 0 01-.7-.7v-7.633a.7.7 0 01.7-.7h2.87zm5.227-2.163l-4.575 3.423a.7.7 0 01-.42.14H5.815v6.232h2.402a.7.7 0 01.42.14l4.575 3.423V8.573zm4.525 3.189a.7.7 0 11.991-.99l3.042 3.048 3.041-3.047a.7.7 0 01.991.989l-3.04 3.046 3.04 3.046a.7.7 0 11-.99.989l-3.042-3.048-3.042 3.048a.7.7 0 01-.99-.99l3.04-3.045-3.04-3.046z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgMute;
